import { jsx as _jsx } from "react/jsx-runtime";
import '../../shared/css/Divider.css';
import '../../shared/css/Stack.css';
import '../../shared/css/generic-styles.css';
var Divider = function (_a) {
    var _b = _a.nested, nested = _b === void 0 ? false : _b, extendLeft = _a.extendLeft, extendRight = _a.extendRight, vertical = _a.vertical;
    var className = "divider".concat(nested ? ' nested' : '').concat(extendLeft ? ' extend-left' : '').concat(extendRight ? ' extend-right' : '').concat(vertical ? ' vertical width-hug' : '');
    return _jsx("div", { className: className });
};
/**
 * # Divider
 * Divides sections by creating a vertical or horizontal line.
 *
 * [See Documentation](https://themeable.systems/documentation)
 *
 * ---
 *
 * ### Style props:
 * `vertical`: Boolean which makes the divider display vertically, rather than horizontally.
 *
 * `spacing`: Boolean. Really meant for building components and should be used sparingly. Removes baked-in spacing.
 *
 * `extendRight`: Boolean. This extends the divider's right edge to take up the space of a container.
 *
 * `extendLeft`: Boolean. This extends the divider's left edge to take up the space of a container.
 */
export { Divider };
